module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.0.0.box.228.108.1426.215.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.25.0.0.box.228.108.1368.98.q.80"
    }
  }, [_vm._v("NATCHEZ CHRISTMAS  CAKE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.25.0.1.box.228.218.1426.105.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("From ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Bobby ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("J. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Potter ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("at ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Post ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("House ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Restaurant ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Natchez, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mississippi ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.25.1.0.box.226.500.1207.804.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.5.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.5.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.5.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.5.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.6.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0026.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.6.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.2.0.box.226.1403.1271.984.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.25.2.0.box.226.1403.1271.984.q.60"
    }
  }, [_vm._v("Cake should be made 4 to 6 weeks in advance. Reduce ginger by half if you use it earlier. Three hours before starting, empty raisins and currants into a saucepan and pour all but 1 cup bourbon over. Simmer over low heat until they are puffed, stirring every 20 minutes. Cream butter and sugar, adding eggs one at a time, beating well. Add jelly and preserves. Mix soda into the molasses. When doubled in size and light brown in color, add to batter. Using reserved bourbon, rinse out molasses jar and add to batter. To the flour, in a separate bowl, add seasonings and thoroughly dredge all nuts and fruits (except raisins and currants). When thoroughly dredged, and using all flour from dredging process, add fruit and nuts to the batter. It is best to put the dredged fruit and nuts in a large preserving kettle and add batter to it. Stir thoroughly. Then add puffed raisins and currants and any bourbon residue that may be left. Prepare 2 tube pans or 4 loaf pans. Line with greased brown paper. Pour in batter"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.26.0.0.box.233.249.1262.213.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  }), _vm._v("\nand bake at 275° for 2 hours. Remove from oven and soak cakes with bourbon—all they will hold. When cool, wrap and store 4 to 6 weeks before cutting. Makes 2 tube cakes or 4 loaf cakes.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.0.0.box.233.249.1265.519.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.1.box.235.543.1263.225.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("When ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cake ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("done ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("should ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("he ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cooled ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pan ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rack, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("about ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("5 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("minutes, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("then ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cooled ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("out ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pan, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rack, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("until ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("heat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("has ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("left. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("There ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("few ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("exceptions ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("which ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("recipe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("point ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("out. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.26.1.0.box.396.952.920.580.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0027.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0.2"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fa391b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0028.vue
// module id = 75
// module chunks = 0